import { ClientApiConfig } from '@quadminds/client-apis/base';

export interface MailApiConfig extends ClientApiConfig {
    /**
     * Default template ID to use if not specified in send methods
     */
    defaultTemplateId?: string;
}
